module.exports = __webpack_public_path__ + "static/media/negozio.5c0e93ee.svg";